import * as React from "react";
import { Placeholder } from "semantic-ui-react";

import { StyledEventImageWrapper } from "../../molecules/Images/EventImage/EventImageStyles";
import { definedAspectRatios } from "../../molecules/Images/EventImage/EventImage";
import { definedCardTypes } from "../../molecules/Cards/EventGridCard";

interface Props {
  type?: definedCardTypes;
}

const CardLoader: React.FC<Props> = ({ type }) => {
  let aspectRatio = definedAspectRatios.aspect16to9;
  if (type === definedCardTypes.calendar) {
    aspectRatio = definedAspectRatios.aspect4to3;
  } else if (type === definedCardTypes.gallery) {
    aspectRatio = definedAspectRatios.aspect1to1;
  }

  return (
    <div>
      <Placeholder fluid>
        <StyledEventImageWrapper aspectRatio={aspectRatio} />
        <Placeholder.Paragraph>
          <Placeholder.Line />
          <Placeholder.Line />
          <Placeholder.Line />
          <Placeholder.Line />
        </Placeholder.Paragraph>
      </Placeholder>
    </div>
  );
};

export default CardLoader;
